import * as React from 'react';
import Box from '../primitives/Box';
import { StyledSystemProps } from '../../theme/StyledSystemProps';

type FieldRowProps = StyledSystemProps & {
  children: React.ReactNode;
  color?: string;
  flex?: number;
};

const FieldRow: React.FC<FieldRowProps> = props => {
  return (
    <Box flexDirection="row" {...props}>
      {props.children}
    </Box>
  );
};

export default FieldRow;

FieldRow.defaultProps = {
  flex: 1,
  mb: 3,
  flexWrap: 'wrap',
};



// WEBPACK FOOTER //
// ./src/components/formElements/FieldRow.tsx